<template>
    <div class="app-main buy-check">
        <div class="top-bar">
          <el-input placeholder="输入商品名称搜索" v-model="title" @change="handleSearch()" class="search-input">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <el-button type="danger" plain @click="handleDel(ids)">删除商品</el-button>
        </div>
        <!-- 商品列表 -->
        <div class="adminList">
            <el-table  :data="tableData" @selection-change="handleSelect" height="630"  style="width: 100%;">
                <el-table-column  type="selection"   width="80"          align="center"> </el-table-column>
                <el-table-column  label="商品图片" align="center" width="130">
                    <template slot-scope="scope">
                        <table-img :src="scope.row.pic_url"></table-img>
                    </template>
                </el-table-column>
                <el-table-column    align="center" prop="title" label="商品所属" width="240" show-overflow-tooltip></el-table-column>
                <el-table-column    align="center" prop="belongs_data" label="商品所属" width="160"></el-table-column>
                <el-table-column    align="left"  label="规格属性" width="200" > 
                    <template slot-scope="scope" >
                        <div v-if="scope.row.specs">
                            <div class="m-bottom-2" v-for="(item, index) in scope.row.specs" :key="index">{{item.attr_symbol_string}}</div>
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column width="240"   align="right"  label="进货数量">
                    <template slot-scope="scope" >
                        <div v-if="scope.row.specs">
                            <div class="shop_var_two" v-for="(item, index) in scope.row.specs" :key="index">
                                <label for="count" class="m-right-10">{{item.attr_symbol_string}}</label>
                                <el-input  v-model="item.up_num"  size="small" @change="changeCount(scope.row,item)" style="width:80px"  />
                            </div>
                        </div>
                    </template>
                </el-table-column> -->
                <el-table-column align="center"  label="添加到订货单">
                    <template slot-scope="scope" >
                        <p class="m-bottom-2"><el-button type="success" plain size="small" @click="handleOrder(scope.row)">添加到订货单</el-button></p>
                        <p>                    <el-button type="danger"  plain size="small" @click="handleDel(scope.row.id)">删除采购商品</el-button></p>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next, jumper" :current-page.sync="page" style="padding:15px 15px 15px 0" :total="total" :page-size="size" @current-change="loadMore"> </el-pagination>
        </div>
    </div>
</template>



<script>
import {  purchase_get, purchase_del, purchase_order } from '@/api/buy.js'
import tableImg from '@/components/Image.vue'
export default {
    components: { tableImg },
    data() {
        return {
            title:'',
            tableData:[],
            total:0,
            page:1,
            size:20,
            ids:'',      // 表格选中的id集合
        }
    },
    methods: {
      
        getData(){
            let params = {
                page:this.page,
                belongs: 2
            }

            if(this.title != ""){
                params.title_search = this.title
            }
            purchase_get(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total     = res.data.total
                    this.size      = res.data.per_page
                }

            })
        },
        loadMore(page){
            this.page = page;
            this.getData()
        },
        // 搜索数据
        handleSearch(){
            this.page = 1;
            this.getData();
        },
        // 表格选中数据 
        handleSelect(rows){
            this.ids = '';
            rows.forEach(e => {
                this.ids += e.id + ','
            })
        },

        // 删除
        handleDel(id){
            purchase_del(id).then(res => {
                if(res){
                    this.getData()
                    this.$message({type:'success', message:res.msg,duration:1500 })
                }
            })
        },

        // 添加到订货单
        handleOrder(it){
            let params = {
                purchase_id:it.id
            }
            purchase_order(params).then(res => {
                if(res){
                    this.getData()
                    this.$message({type:'success', message:res.msg,duration:1500 })
                }
            })
        },
    },
    mounted(){
        this.getData();
    },
    activated() {
        this.getData()
    },
}
</script>




